(function () {
  function initImageLinkCoverflow() {
    document.querySelectorAll('.image-link-marquee__swiper').forEach(el => {
      if (el.classList.contains('is-initialized')) return;

      new Swiper(el, {
        loop: true,
        centeredSlides: false,
        slidesPerView: 'auto',
        speed: 3000,

        effect: 'coverflow',

        coverflowEffect: {
          rotate: 0,
          stretch: -10,   // ← PC 基準
          depth: 0,
          modifier: 1,
          slideShadows: false,
        },

        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },

        allowTouchMove: true,
        grabCursor: true,

        /* ===== レスポンシブ ===== */
        breakpoints: {
          0: {
            coverflowEffect: {
              rotate: 0,
              stretch: -6,   // ← スマホでは弱める
              depth: 0,
              modifier: 1,
            },
          },
          750: {
            coverflowEffect: {
              rotate: 0,
              stretch: -10,  // ← PC / タブレット
              depth: 0,
              modifier: 1,
            },
          },
        },
      });

      el.classList.add('is-initialized');
    });
  }

  document.addEventListener('DOMContentLoaded', initImageLinkCoverflow);
  document.addEventListener('shopify:section:load', initImageLinkCoverflow);
})();